import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import StatusOption from './statusOption';
import Icon, { GLYPHS } from '../../../common/icon';
import {
  getFilters,
} from '../appointmentSelector';

class StatusFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { isActive: false };
  }

  toggleDropdown = e => {
    e.preventDefault();
    this.setState({ isActive: !this.state.isActive });
  };

  handleClickOutside = () => {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    }
  };

  isChecked() {
    return parseInt(this.props.statusFilter.status__in, 10) === 0;
  }

  render() {
    const {
      toggleDropdown,
      props: {
        updateStatusFilter,
      },
    } = this;

    const filters = (
      <StatusOption
        key="hidden"
        optionText="Hide cancelled"
        updateStatusFilter={updateStatusFilter}
        checked={this.isChecked()}
      />
    );

    const dropdownBodyClass = classNames(
      'c-tooltip c-tooltip--barbers u-p0', {
        'is-active': this.state.isActive,
      }
    );

    const dropdownTriggerClass = classNames(
      'c-dropdown-new', {
        'is-active': this.state.isActive,
      }
    );

    return (
      <div className="has-tooltip o-flexbox__item is-hidden">
        <a
          href=""
          className={dropdownTriggerClass}
          onClick={toggleDropdown}
        >
          Filters
          <Icon glyph={GLYPHS.arrow} className="c-dropdown-icon" />
        </a>
        <div className={dropdownBodyClass}>
          <ul className="c-separator-list">
            <li className="c-separator-list__item">
              {filters}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

StatusFilter.propTypes = {
  updateStatusFilter: PropTypes.func.isRequired,
  statusFilter: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  statusFilter: getFilters(state),
});

export default connect(mapStateToProps, null)(onClickOutside(StatusFilter));
